// extracted by mini-css-extract-plugin
module.exports = {"container":"FAQButton_container__1L5iM","button":"FAQButton_button__v0fPl","hint":"FAQButton_hint__1BI_4"};